import { ModelOptions } from './model-options';

export class RatingModelOptions extends ModelOptions {
    public readonly required: boolean;
    public readonly maxIcons: number;
    public readonly readonly: boolean;
    public constructor({
        maxRatings = 5,
        required = false,
        readonly = false,
    }: {
        maxRatings?: number;
        required?: boolean;
        initialSelection?: number;
        readonly?: boolean;
    } = {}) {
        super();
        this.maxIcons = maxRatings;
        this.required = required;
        this.readonly = readonly;
    }
}

export class RatingModelOptionsFromJson extends RatingModelOptions {
    public constructor(data: JsonRatingModelOptions) {
        super({
            maxRatings: data.maxRatings ? data.maxRatings : 5,
            required: data.required,
            readonly: data.readonly,
        });
    }
}

export interface JsonRatingModelOptions {
    required: boolean;
    maxRatings: number;
    readonly: boolean;
}
